// extracted by mini-css-extract-plugin
export default {"actionsCell":"TableCell_actionsCell__p+Um8","checkboxCell":"TableCell_checkboxCell__-yTKE","link":"TableCell_link__eKsNE"};